<script setup lang="ts">
import BasicBlock from '@/components/shared/blocks/BasicBlock.vue';
import { MealEntry } from '@/graphql/custom-types';

interface Props {
  event?: MealEntry;
}

defineProps<Props>();
</script>

<template>
  <BasicBlock
    v-if="
      event &&
      event.__typename === 'RepeatingMeal' &&
      event.repeat.rset.rule.FREQ
    "
    :icon="['far', 'repeat']"
    :ariaDescription="$t('global.repeats')"
  >
    {{ $t(`rrule.` + event.repeat.rset.rule.FREQ) }}
  </BasicBlock>
</template>
